import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
  InfoWrapper
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import CommonManager, { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";
import SelectFilterAPI from "../../../../common/components/form/SelectFilterAPI";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import Toggle from "react-toggle";

const commonManager = new CommonManager();

export class TTSModelAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `TTS Model`;
    this.moduleUrl = `config/tts`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = {}) {
    console.log("editData", this.props.tagList);
    editData = editData || {};
    this.state = {
      isLoading: false,
      // type:
      //   editData && Array.isArray(editData.type) && editData.type.length > 0
      //     ? editData.type[0]._id
      //     : null,
      // initialType: (editData && editData.type) || [],
      // gender: editData.gender || "",
      // language_code: editData.language_code || [],
      // voice_name: editData.voice_name || "",
      // language: editData.language || "",
      // voice_id: editData.voice_id || "",
      // voice_type: editData.voice_type || "",
      // meta: editData.meta || {},
      // neural_voice: editData.neural_voice || "",
      // standard_voice: editData.standard_voice || "",
      // languageValue: this.getInitialValue(editData.language_code) || null,
      provider: editData && Array.isArray(editData.provider) && editData.provider.length > 0
        ? editData.provider[0]._id
        : null,
      initialProvider: editData && editData.provider || [],
      name: editData.name || "",
      label: editData.label || "",
      price: editData.price || "",
      meta: editData.meta || {},
      status: editData.status || false,
      deprecated: editData.deprecated || false,
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      // type: null,
      // gender: "",
      // language_code: [],
      // voice_name: "",
      // language: "",
      // voice_id: "",
      // voice_type: "",
      // meta: {},
      // neural_voice: "",
      // standard_voice: "",
      // value: null,
      provider: null,
      name: "",
      label: "",
      price: "",
      meta: {},
      status: false,
      deprecated: false,
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    let _this = this;
    let tData = {
      // type: this.state.type,
      // gender: this.state.gender,
      // language_code: this.state.language_code,
      // voice_name: this.state.voice_name,
      // language: this.state.language,
      // voice_id: this.state.voice_id,
      // voice_type: this.state.voice_type,
      // meta: this.state.meta,
      // neural_voice: this.state.neural_voice,
      // standard_voice: this.state.standard_voice,
      provider: this.state.provider,
      name: this.state.name,
      label: this.state.label,
      price: this.state.price,
      meta: this.state.meta,
      status: this.state.status,
      deprecated: this.state.deprecated,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
          }
          this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PATCH"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.closeModal(true);
          _this.props.update();
          Alert.success(`${this.moduleName} created successfully.`);
          _this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          this.setState({ isLoading: false });
        },
        "public"
      );
    }
  }

  handleJSONChange = (event) => {
    // Check if the JSON input is valid
    if (event.jsObject) {
      this.setState({
        meta: event.jsObject, // Update the state with the parsed JSON object
      });
    }
  };

  getInitialValue(list) {
    let initialList = [];
    if (list && list.length) {
      list.map((e) => {
        initialList.push({
          value: e,
          label: e,
          className: "Select-create-option-placeholder",
        });
      });
    }
    return initialList;
  }

  handleOnChange(value) {
    let language_code = [];
    this.setState({ languageValue: value });
    value.map((e) => {
      language_code.push(e.value);
    });
    this.setState({ language_code: language_code });
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = ["e", "E", "-"];
    const re = /^[\.0-9]*$/;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          {/* <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel required>Type</ControlLabel>
                <SelectFilterAPI
                  dataUrl={"config/tts/provider"}
                  global={true}
                  selected={this.state.type}
                  initialValues={commonManager.initialData(
                    this.state.initialType,
                    "name",
                    "_id"
                  )}
                  dataValue={"type"}
                  dataLabel={"label"}
                  label={"Type"}
                  multi={false}
                  required={true}
                  onSelect={(items, name, ops) => {
                    if (items) {
                      this.setState({
                        type: items,
                        initialType: commonManager.selectedSingleData(
                          items,
                          ops
                        ),
                      });
                    } else {
                      this.setState({
                        type: null,
                      });
                    }
                  }}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Gender", {
                defaultValue: "",
                placeholder: "Gender",
                autoFocus: false,
                required: true,
                id: "gender",
                value: this.state.gender,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    gender: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel>Language Code</ControlLabel>
                <Select.Creatable
                  key={`Language Code`}
                  placeholder={"Language Code"}
                  value={this.state.languageValue}
                  onChange={(value) => this.handleOnChange(value)}
                  multi={true}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Voice Name", {
                defaultValue: "",
                placeholder: "Voice Name",
                autoFocus: false,
                required: true,
                id: "voiceName",
                value: this.state.voice_name,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    voice_name: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Language", {
                defaultValue: "",
                placeholder: "Language",
                autoFocus: false,
                required: true,
                id: "language",
                value: this.state.language,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    language: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Voice ID", {
                defaultValue: "",
                placeholder: "Voice ID",
                autoFocus: false,
                required: true,
                id: "voiceId",
                value: this.state.voice_id,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    voice_id: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Voice Type", {
                defaultValue: "",
                placeholder: "Voice Type",
                autoFocus: false,
                required: true,
                id: "voiceType",
                value: this.state.voice_type,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    voice_type: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel>Meta</ControlLabel>
                <JSONInput
                  id="a_unique_id"
                  placeholder={this.state.meta} // Ensure this is valid JSON
                  locale={locale}
                  height="250px"
                  width="100%"
                  onChange={this.handleJSONChange}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Neural Voice", {
                defaultValue: "",
                placeholder: "Neural Voice",
                autoFocus: false,
                required: true,
                id: "neuralVoice",
                value: this.state.neural_voice,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    neural_voice: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Standard Voice", {
                defaultValue: "",
                placeholder: "Standard Voice",
                autoFocus: false,
                required: true,
                id: "standardVoice",
                value: this.state.standard_voice,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    standard_voice: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper> */}
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel required>Provider</ControlLabel>
                <SelectFilterAPI
                  dataUrl={"config/tts/provider"}
                  global={true}
                  selected={this.state.provider}
                  initialValues={commonManager.initialData(
                    this.state.initialProvider,
                    "name",
                    "_id"
                  )}
                  dataValue={"type"}
                  dataLabel={"label"}
                  label={"Type"}
                  multi={false}
                  required={true}
                  onSelect={(items, name, ops) => {
                    if (items) {
                      this.setState({
                        provider: items,
                        initialProvider: commonManager.selectedSingleData(
                          items,
                          ops
                        ),
                      });
                    } else {
                      this.setState({
                        provider: null,
                      });
                    }
                  }}
                />
              </FormGroup>
              {/* {this.renderFormGroup("Provider", {
                defaultValue: "",
                placeholder: "Provider",
                autoFocus: false,
                required: true,
                id: "provider",
                value: this.state.provider,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    provider: e.target.value,
                  });
                },
              })} */}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Name", {
                defaultValue: "",
                placeholder: "Name",
                autoFocus: false,
                required: true,
                id: "name",
                value: this.state.name,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    name: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Label", {
                defaultValue: "",
                placeholder: "Label",
                autoFocus: false,
                required: true,
                id: "label",
                value: this.state.label,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    label: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Price", {
                defaultValue: "",
                placeholder: "Price",
                autoFocus: false,
                required: true,
                id: "price",
                value: this.state.price,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value)
                  ) {
                    return false;
                  }
                  this.setState({ price: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel>Meta</ControlLabel>
                <JSONInput
                  id="a_unique_id"
                  placeholder={this.state.meta} // Ensure this is valid JSON
                  locale={locale}
                  height="250px"
                  width="100%"
                  onChange={this.handleJSONChange}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <InfoWrapper>
                  <ControlLabel>Status</ControlLabel>
                  <Toggle
                    checked={this.state.status}
                    defaultChecked={this.state.status}
                    icons={{
                      checked: <span>Yes</span>,
                      unchecked: <span>No</span>,
                    }}
                    onChange={(event) => {
                      const value = event.target.checked;
                      this.setState({
                        status: value
                      })
                    }}
                  />
                </InfoWrapper>
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <InfoWrapper>
                  <ControlLabel>Deprecated</ControlLabel>
                  <Toggle
                    checked={this.state.deprecated}
                    defaultChecked={this.state.deprecated}
                    icons={{
                      checked: <span>Yes</span>,
                      unchecked: <span>No</span>,
                    }}
                    onChange={(event) => {
                      const value = event.target.checked;
                      this.setState({
                        deprecated: value
                      })
                    }}
                  />
                </InfoWrapper>
              </FormGroup>
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

TTSModelAddEdit.propTypes = {
  group: PropTypes.array,
};

TTSModelAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default TTSModelAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/TTSModel/components/TTSModelAddEdit.js